import { Injectable } from '@angular/core';
import { readCookie } from './cookies';

export const DEFAULT_LANG = 'en';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  /** `?lang` → `dashboardLocale` cookie → browser language → `en`; used for the UI and the `lang` sent with the sign-up. */
  resolve(queryLang: string | undefined): string {
    return queryLang || readCookie('dashboardLocale') || navigator.language.split('-')[0] || DEFAULT_LANG;
  }
}
